import { observer } from 'mobx-react';
import { FC, ReactElement, useCallback } from 'react';
import Skeleton from 'react-loading-skeleton';
import cookiesStore from '../../store/cookiesStore';
import { TBooleanInNumber } from '~/types/main';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import Text from '~/view/components/Text/Text';

const CookiesEnabledSwitcher: FC = observer((): ReactElement => {
  const { isFirstLoading, cookies } = cookiesStore;

  const onEnabledChanged = useCallback((cookiesEnabled: TBooleanInNumber) => {
    cookiesStore.changeCookiesHandler({ cookiesEnabled });
  }, []);

  return (
    <div className="d-flex flex-row align-items-center">
      {isFirstLoading ? (
        <Skeleton width={50} height={30} style={{ borderRadius: 30 }} />
      ) : (
        <Switcher status={cookies.cookiesEnabled} onChange={onEnabledChanged} />
      )}
      <Text type="switcher-label" text="enable" />
    </div>
  );
});

export default CookiesEnabledSwitcher;
